import { render, staticRenderFns } from "./SearchSong.vue?vue&type=template&id=99f5a784&scoped=true&"
import script from "./SearchSong.vue?vue&type=script&lang=js&"
export * from "./SearchSong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f5a784",
  null
  
)

export default component.exports